import { AppBar, Box, Grid, Toolbar, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { UfficioMappaContainer } from "../../common";
import {
    ResearchContext,
    ResearchProvider
} from './ResearchContext';

import logoRepubblica from "../../../images/logo-repubblica-bianca.png";

export const WidgetContent = () => {

    const location = useLocation();

    const [queryParamsData, setQueryParamsData] = useState({});

    const {
        state,

        handleWidgetSearchSubmit,

        tableResultTitle,
        tableResultSubtitle,
        tableResultSubtitle2,

        isLoadingFilters,

    } = useContext(ResearchContext)



    const {
        uffici,
        altriUffici,
        tipiUffici,
    } = state;

    const [filtriTipiUfficiEnabled, setFiltriTipiUfficiEnabled] = useState([]);

    useEffect(() => {
        setFiltriTipiUfficiEnabled(tipiUffici.map(x => x.id));
    }, [tipiUffici]);

    useEffect(() => {

        const queryParams = new URLSearchParams(location.search);
        var altezza = queryParams.get('altezza');
        var larghezza = queryParams.get('larghezza');
        var comune = queryParams.get('comune');
        var distretto = queryParams.get('distretto');
        var circondario = queryParams.get('circondario');
        var provincia = queryParams.get('provincia');
        var regione = queryParams.get('regione');
        var tipoUfficio = queryParams.get('tipoUfficio');
        var testo = queryParams.get('testo');
        var includiTabellaRisultati = queryParams.get('includiTabellaRisultati');

        setQueryParamsData({
            altezza: altezza,
            larghezza: larghezza,
            includiTabellaRisultati: includiTabellaRisultati.toLowerCase() == "true"
        });

        if (!isLoadingFilters)
            handleWidgetSearchSubmit(comune, regione, provincia, distretto, circondario, tipoUfficio, testo);

    }, [isLoadingFilters])


    return (
        <div style={{
            'height': `${queryParamsData.altezza}px`,
            'width': `${queryParamsData.larghezza}px`,
        }}>
            <div style={{
                'height': `${queryParamsData.altezza - 48}px`,
                'width': `${queryParamsData.larghezza}px`,
            }}>
                <UfficioMappaContainer
                    title={tableResultTitle}
                    subtitle={tableResultSubtitle}
                    subtitle2={tableResultSubtitle2}
                    ufficiListVisibilityDefault={queryParamsData.includiTabellaRisultati}
                    filtriUfficiDefault={false}
                    hideBntUfficiList={!queryParamsData.includiTabellaRisultati}
                    isWidgetMap={true}
                    ufficiList={uffici ?? []}
                    altriUfficiList={altriUffici ?? []}
                    filtriTipiUffici={tipiUffici ?? []}
                    filtriTipiUfficiEnabled={filtriTipiUfficiEnabled}
                    setFiltriTipiUfficiEnabled={setFiltriTipiUfficiEnabled}
                />
            </div>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static" sx={{ boxShadow: "none" }}>
                    <Toolbar variant="dense" sx={{ padding: "0px!important" }}>
                        <Grid container>
                            <a
                                href="https://www.giustizia.it/"
                                style={{
                                    textDecoration: "none",
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <img
                                    src={logoRepubblica}
                                    style={{ width: 60, }}
                                />
                                <Typography
                                    fontSize=".778em"
                                    fontWeight={600}
                                    sx={{ width: "50%", color: "white", whiteSpace: "nowrap" }}
                                >
                                    Ministero della Giustizia
                                </Typography>
                            </a>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Box>
        </div>
    );
}


export const WidgetPage = () => {

    return (
        <ResearchProvider>
            <WidgetContent />
        </ResearchProvider>
    );
}